import I18n from 'I18n';
import getIn from 'immutable-less/transmute/getIn';
import { DataSourceType } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
import { isVisibleWhenSearchFiltered } from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/utils/isVisibleWhenSearchFiltered';
const getGroupType = type => {
  if (type === 'datetime') {
    return 'date';
  }
  return type;
};
export const filterAndGroupPropertiesByType = ({
  dataSource,
  hideNestedDataSources,
  searchFilterString
}) => {
  const {
    dataSourceProperties = {}
  } = dataSource || {};
  return Object.values(dataSourceProperties).filter(property => isVisibleWhenSearchFiltered({
    property,
    searchFilterString
  })).reduce((prevValue, property) => {
    let type = getGroupType(getIn(['metadata', 'typeDefinition', 'type'], property));
    if (!hideNestedDataSources && property.dataPropertyType === DataSourceType.CONNECTION) {
      type = DataSourceType.CONNECTION;
    }
    const prevValueProperties = prevValue.get(type) || [];
    prevValueProperties.push(property);
    return prevValue.set(type, prevValueProperties);
  }, new Map());
};
export const getGroupLabel = groupKey => {
  const groupLabelsByKey = new Map([['string', I18n.text('automation-ui-formula-editor.data-passing-panel.ux-revised-mode.grouped-properties.string-group')], ['enumeration', I18n.text('automation-ui-formula-editor.data-passing-panel.ux-revised-mode.grouped-properties.enumeration-group')], ['number', I18n.text('automation-ui-formula-editor.data-passing-panel.ux-revised-mode.grouped-properties.number-group')], ['date', I18n.text('automation-ui-formula-editor.data-passing-panel.ux-revised-mode.grouped-properties.date-group')], ['bool', I18n.text('automation-ui-formula-editor.data-passing-panel.ux-revised-mode.grouped-properties.boolean-group')], [DataSourceType.CONNECTION, I18n.text('automation-ui-formula-editor.data-passing-panel.ux-revised-mode.grouped-properties.nested-group')]]);
  return groupLabelsByKey.get(groupKey) || '';
};
export const getGroupSortOrder = key => {
  const orderByKey = new Map([[DataSourceType.CONNECTION, 1], ['string', 2], ['enumeration', 3], ['number', 4], ['date', 5], ['bool', 6]]);
  return orderByKey.get(key) || 0;
};
export const getDefaultOpenPropertyGroups = ({
  groupedPropertiesByType,
  propertyTypeAllowList
}) => {
  const groupKeys = Array.from(groupedPropertiesByType.keys()).sort((a, b) => b === DataSourceType.CONNECTION ? -1 : 0);
  if (groupKeys.length <= 0) {
    return new Map();
  }
  let openTypeKey = groupKeys.shift();
  if (propertyTypeAllowList && propertyTypeAllowList.length > 0) {
    const firstAllowTypeKey = propertyTypeAllowList[0];
    if (firstAllowTypeKey && groupKeys.some(key => key === firstAllowTypeKey)) {
      openTypeKey = firstAllowTypeKey;
    }
  }
  return new Map([[openTypeKey, true]]);
};